module.exports = __webpack_public_path__ + "img/produtos.d08c7ab4.svg";